import { render, staticRenderFns } from "./InputSampleDashboard.vue?vue&type=template&id=03051f38&scoped=true&"
import script from "./InputSampleDashboard.vue?vue&type=script&lang=js&"
export * from "./InputSampleDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InputSampleDashboard.vue?vue&type=style&index=0&id=03051f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03051f38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VIcon,VSwitch})
